module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Abendstimmung")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Hin durch den Forst schießt eine weiße\nSchlange,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nspitz ist ihr Haupt, ihr Schweif verweht im Winde;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndarunter braust auf stählernem Gewinde"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nder Erdenpuls in nimmermüdem Gange.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Verschwunden ist sie tief im Forste lange,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nstumm ragt die Kiefer, um die rote Rinde"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nspielt schon der Nachthauch, schweifen Nebel linde,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund Uhuschrei tönt ferneher und bange.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ein Tümpel liegt in weltvergeßnen Träumen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nvom Frühlingsregen angefüllt, am Raine;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nes spiegeln drin sich einsam Ost und Westen.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Tiefblau der Ost steht über schwarzen Bäumen,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\ndie Stirn geziert mit einem Demantsteine;"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nder Westen prahlt mit fahlen Sonnenresten. "), _c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page31",
      "title": "wedi/Konmax"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a25d6ccc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0016.vue
// module id = 102
// module chunks = 0